import AppIcon from "./AppIcon";

const _BODY_CLASSES = {
  basic: "border-border bg-bg-light",
  warning: "border-warning bg-warning/10",
  danger: "border-destructive bg-destructive/10",
  success: "border-success bg-success/10",
  primary: "border-primary bg-primary/10",
};

const _TEXT_CLASSES = {
  basic: "text-fg",
  warning: "text-warning-fg",
  danger: "text-destructive-fg",
  success: "text-success-fg",
  primary: "text-primary-fg",
};

const _ICON_CLASSES = {
  basic: "text-muted-fg",
  warning: "text-warning",
  danger: "text-destructive",
  success: "text-success",
  primary: "text-primary",
};

export default function Alert({ mode, icon, body, className }) {
  return (
    <div className={`flex items-center border-l-4 pl-4 h-12 pr-2 space-x-4 ${_BODY_CLASSES[mode]} ${className}`}>
      {icon && <AppIcon code={icon} className={`h-8 w-8 ${_ICON_CLASSES[mode]}`} aria-hidden="true" />}
      <div className={`${_TEXT_CLASSES[mode]} w-full`}>{body}</div>
    </div>
  );
}
